import React, { useState } from 'react';
import { useUserContext } from '../../context/UserContext';
import VideoService from '../../service/VideoService';
import { CustomButton } from '../Button/Button';
import { CustomInput } from '../Input/Input';
import styles from './ProtectedVideoModal.module.scss';
import { useTranslation } from 'react-i18next';
import MobileHeader from '../MobileHeader';

const ProtectedVideoModal = ({ videoId, videoPassword, setVideoPassword, onCheckedSuccessfully }) => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const mediaMatch = window.matchMedia('(max-width: 900px)');
  const [isMobileView] = useState(mediaMatch.matches);

  const { user } = useUserContext();

  const { t } = useTranslation();

  const onChangeInput = e => {
    setError('');
    const field = e.target.name;
    if (field === 'password') {
      setVideoPassword(e.target.value);
    }
  };

  const onSubmitClick = () => {
    const checkPassword = async () => {
      setLoading(true);
      try {
        const videoDetails = await VideoService.getProtectedVideo(videoId, videoPassword, user !== null);
        onCheckedSuccessfully(videoDetails);
      } catch (err) {
        if (err.request.status === 400) {
          setError(t('video.protected_modal.error.incorrect_password'));
        } else {
          setError(t('video.protected_modal.error.something_went_wrong'));
        }

        setIsCheckedSuccessfully(false);
      } finally {
        setLoading(false);
      }
    };

    if (videoPassword === '') {
      setError(t('video.protected_modal.error.password_is_required'));
    } else {
      checkPassword();
    }
  };

  if (isMobileView) {
    return (
      <>
        <MobileHeader showMenuBtn={true} />
        <div className={styles.mobilePasswordContainer}>
          <h2>{t('video.protected_modal.title')}</h2>
          <div className={styles.inputContainer}>
            <CustomInput
              isShow
              type="password"
              name="password"
              customStyles={{ paddingBottom: '16px' }}
              placeholder={t('video.protected_modal.input.placeholder')}
              invalid={error !== ''}
              validateMessage={error}
              onChange={onChangeInput}
            />
          </div>
          <CustomButton
            variant="primary"
            label={t('video.protected_modal.button.label')}
            onClick={onSubmitClick}
            loading={loading}
            disabled={error !== '' || videoPassword === ''}
            loadingText={t('video.protected_modal.button.loadingText')}
            className={styles.mobileSubmitButton}
          />
        </div>
      </>
    );
  } else {
    return (
      <div className={styles.pageContainer}>
        <div className={styles.overlayContainer}>
          <form className={styles.overlaySection} onSubmit={onSubmitClick}>
            <p className={styles.heading}>{t('video.protected_modal.title')}</p>
            <p className={styles.subHeading}>{t('video.protected_modal.text')}</p>
            <div className={styles.inputContainer}>
              <CustomInput
                isShow
                fieldName={t('video.protected_modal.input.name')}
                type="password"
                name="password"
                customStyles={{ paddingBottom: '16px' }}
                placeholder={t('video.protected_modal.input.placeholder')}
                invalid={error !== ''}
                validateMessage={error}
                onChange={onChangeInput}
              />
            </div>
            <CustomButton
              variant="primary"
              label={t('video.protected_modal.button.label')}
              onClick={onSubmitClick}
              loading={loading}
              disabled={error !== '' || videoPassword === ''}
              loadingText={t('video.protected_modal.button.loadingText')}
              className={styles.submitButton}
            />
          </form>
        </div>
      </div>
    );
  }
};

export default ProtectedVideoModal;
